import { forwardRef } from 'react';
import { TextField, TextFieldProps } from './textField';

export type NumberFieldProps = TextFieldProps;
export const NumberField = forwardRef<HTMLDivElement, NumberFieldProps>(function NumberField({ ...props }, ref) {
  return <TextField {...props} type="number" />;
});
